import classNames from "classnames";

import type { SortableContextProps } from "../Provider";
import { SortableContext } from "../Provider";

export interface ListProps extends SortableContextProps {
  children: React.ReactNode;
  className?: string;
  gap?: number;
}

export const List = ({
  gap = 2,
  className = "",
  children,
  ...rest
}: ListProps) => (
  <SortableContext {...rest}>
    <ul
      // @todo Fix this. class should not be dynamic https://tailwindcss.com/docs/content-configuration#dynamic-class-names
      // eslint-disable-next-line tailwindcss/no-custom-classname -- dynamic Tailwind class
      className={classNames(`grid gap-${gap}`, className)}
    >
      {children}
    </ul>
  </SortableContext>
);
